import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { FileIcon } from '@/shared/assets/icons/file-icon';
import { ClearButton } from '@/shared/components/ui/button/clear-button/clear-button';
import {
  TFileInfo,
  TFileUploadedProps,
} from '@/shared/components/ui/form/components/file-dropzone/components/file-uploaded/file-uploaded.types';
import {
  FileInfo,
  FileInfoPrimary,
  FileInfoSecondary,
  FileUploadedContainer,
} from '@/shared/components/ui/form/components/file-dropzone/file-dropzone.styled';
import { formatFileSize } from '@/shared/utils/format';

export const FileUploaded: React.FC<TFileUploadedProps> = ({
  value,
  disabled,
  onRemove,
}) => {
  const { t } = useTranslation();
  const isMultiple = Array.isArray(value);

  const createFileInfo = (file: File): TFileInfo & { originalFile: File } => ({
    name: file.name,
    size: formatFileSize(file.size),
    originalFile: file,
  });

  const getFileInfo = () => {
    if (!value) return [];
    return Array.isArray(value)
      ? value.map(createFileInfo)
      : [createFileInfo(value)];
  };

  const handleClick = (file: File) => {
    if (onRemove) {
      onRemove(file);
    }
  };

  return (
    <FileUploadedContainer $multiple={isMultiple}>
      {getFileInfo().map((info) => (
        <Stack
          key={info.name}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          gap="1rem"
        >
          <FileInfo>
            <FileIcon variant="primary" />
            <FileInfoSecondary>
              {t('ui:selected_file', { count: 1 })}:
            </FileInfoSecondary>
            <FileInfoPrimary>{info.name}</FileInfoPrimary>
            <FileInfoSecondary>({info.size})</FileInfoSecondary>
          </FileInfo>
          <ClearButton
            disabled={disabled}
            onClick={() => handleClick(info.originalFile)}
            circle
          />
        </Stack>
      ))}
    </FileUploadedContainer>
  );
};
